<template>
  <v-container class="app-container--width-max">
    <v-alert
      color="var(--orange-100)"
      class="quote-expired-message ma-5"
      v-if="this.isExpired"
    >
      <div class="d-flex flex-no-wrap error-message">
        <div class="mr-3">
          <v-icon color="var(--orange-500)">mdi-alert</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Sorry!</span> This quote has expired.
          Please check all the details below are accurate and submit a new
          quote.
        </div>
      </div>
    </v-alert>

    <router-view v-show="!restoringLastStep" />

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { applyThirdPartyId } from "@/common/utils";
import { ROUTE_NAME } from "@/constants/route.constants";
import {
  APPLICATION_MODULE,
  QUESTIONS_MODULE,
} from "@/store/types/module-types";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "LandlordsB2BLayout",
  props: {
    urlParams: Object,
  },
  data() {
    return {
      overlay: false,
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["restoringLastStep", "userId"]),
    ...mapGetters(QUESTIONS_MODULE, [
      "hasCredentials",
      "isExpired",
      "getQuoteRequestId",
    ]),
    currentRouteName() {
      return this.$route.name;
    },
    isQuestionSteps() {
      return [
        ROUTE_NAME.LANDLORDS.B2B.YOUR_DETAILS,
        ROUTE_NAME.LANDLORDS.B2B.PROPERTY_DETAILS,
      ].includes(this.currentRouteName);
    },
    isQuoteResultStep() {
      return (
        ROUTE_NAME.LANDLORDS.B2B.QUOTATION_RESULT === this.currentRouteName
      );
    },
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["handleSaveAndExitOnResults"]),
    ...mapActions(QUESTIONS_MODULE, {
      handleSaveAndExitQuestions: "handleSaveAndExit",
    }),
    ...mapActions(APPLICATION_MODULE, {
      handleSaveAndExitApplication: "handleSaveAndExit",
    }),
  },
  async mounted() {
    try {
      applyThirdPartyId(false, this.userId);
      return;
    } catch (e) {
      console.error(e);
    }
  },
};
</script>

<style scoped>
.app-container--width-max {
  max-width: 1250px;
}
</style>
